import { supabase } from '../supabaseClient';
//?? Project wings by rpc
async function getAllWingsByProjectId(projectid) {

    var query;
    query = supabase.rpc('getwingsbyproject', {projectid  : projectid }, { count: 'exact' })
    const { data, count, error } = await query
    if (data) return { data, count };
    else throw error;
}


async function getAllUnitsByWingId(projectId, wingId) {
    const { data, error, count } = await supabase
    .from('ProjectInventoryRelations')
    .select('*,mergeId(*),unitId(*,inventoryTypeId(*))', { count: 'exact' })
    .eq('projectId', projectId)
    .eq('wingId', wingId)
    .filter('unitId.inventoryStatusId', 'in', '("51c40f6a-176d-4ef9-a2a7-a2c0569da025")')
    if (data) return { data, count };
    else throw error;
}
// ??Events wings
async function getWingsByLaunchIdFromRpc(launchId) {
    var query;
    query = supabase.rpc('getwingsbylaunch', {launchid : launchId}, { count: 'exact' })
    const { data, count, error } = await query
    if (data) return { data, count };
    else throw error;
}
async function geLaunchInventory(projectId,launchId, wingId) {
    let query = supabase
        .from('LaunchInventoryRelations')
        .select('*,launchId(*,eventId(*)),unitId(*,inventoryTypeId(*),inventoryMergeId(*,unit1Id(*,inventoryTypeId(*)),unit2Id(*,inventoryTypeId(*))),wingId(*))',{ count: 'exact' })
        .eq('launchId.projectId', projectId)
        .eq('launchId.launchId',launchId)
        .eq('wingId', wingId)
        .filter('unitId.inventoryStatusId', 'in', '("51c40f6a-176d-4ef9-a2a7-a2c0569da025")')
        // .lt('launchId.eventId.endDateTime', Date.now());

    const { data, count, error } = await query
    if (data) return { data, count };
    else throw error;
}
async function getAllUnitsByProjectId(projectId) {
    const { data, error, count } = await supabase
        .from('Inventory')
        .select('* , inventoryTypeId(*) , InventoryStatus(status)', { count: 'exact' })
        .eq('projectId', projectId)
    if (data) return { data, count };
    else throw error;
}
async function getProjectPricing(projectId, wingId, inventoryTypeId) {
    const { data, error, count } = await supabase
        .from('ProjectPricing')
        .select('*', { count: 'exact' })
        .eq('projectId', projectId)
        .eq('wingId', wingId)
        .eq('inventoryTypeId', inventoryTypeId);
    if (data) return { data, count };
    else throw error;
}
async function getProjectCollaterals(cpId, projectId) {
    console.log(cpId)
    const { data, error, count } = await supabase
        .from('ProjectCollateralCpRelations')
        .select('*,ProjectCollaterals!inner(*)', { count: 'exact' })
        .eq('cpId', cpId)
        .lte('startDateTime', Date.now()).gte('endDateTime', Date.now())
        .eq('ProjectCollaterals.projectId', projectId);
    if (data) return { data, count };
    else throw error;
}

export { getAllWingsByProjectId, getAllUnitsByWingId, 
    getAllUnitsByProjectId, getProjectCollaterals
    ,getProjectPricing,getWingsByLaunchIdFromRpc,geLaunchInventory}